import * as authApi from '../modules/auth/api';

// Aug 2026 — open a NEW TAB in the driver app logged in AS the given driver
// (REAL session — actions persist; the app shows a red banner). Token rides in
// the URL fragment so it never reaches server/proxy logs. OVO-209 rules for
// the base URL: never fall back to localhost on a deployed build.
export async function openDriverAppAsDriver(driverId, messageApi) {
  const { response, error } = await authApi.impersonateDriverLogin(driverId);
  if (error || !response?.access_token) {
    messageApi?.error(error?.data?.message || error?.message || 'Could not log in as this driver');
    return false;
  }
  const isLocalHost = /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);
  const configured = process.env.REACT_APP_DRIVER_APP_URL || (isLocalHost ? 'https://localhost:3003' : '');
  if (!configured) {
    messageApi?.error('Driver app URL is not configured for this environment');
    return false;
  }
  const base = configured.replace(/\/$/, '');
  window.open(`${base}/impersonate#token=${encodeURIComponent(response.access_token)}`, '_blank');
  return true;
}
